module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-mobile-2.82ce07ac.png";